import request from '@/utils/request'
import md5 from 'md5'
// 获取验证码
export function fetchCode(query) {
  return request({
    url: '/api/v1/phonecode',
    baseURL: 'other',
    method: 'get',
    params: query
  })
}

// 手机验证码登录
export function loginByPhone(data) {
  return request({
    url: `/api/v1/login/phone?phone=${data.phone}&phoneCode=${data.phoneCode}`,
    baseURL: 'other',
    method: 'post',
    data
  })
}

// 获取验证码
export function loginByWachat(query) {
  return request({
    url: '/api/v1/login/wechat',
    baseURL: 'other',
    method: 'get',
    params: query
  })
}

// 用户登录
export function loginAccount(query) {
  return request({
    url: '/api/v1/login',
    baseURL: 'other',
    method: 'get',
    params: query
  })
}

// 获取国家区号
export function getCountries(query) {
  return request({
    url: '/api/v1/countries',
    baseURL: 'other',
    method: 'get',
    params: query
  })
}

// 手机登录并绑定微信
export function bindPhone(query) {
  return request({
    url: '/api/v1/wxsub/phoneloginandbind',
    baseURL: 'other',
    method: 'get',
    params: query
  })
}

// 手机号+密码登陆
export function loginByPassword(data) {
  return request({
    url: `/api/v1/login/phonewithpasswd?phone=${data.phone}&telAreaCode=${data.telAreaCode}&passwd=${md5(data.passwd)}`,
    baseURL: 'other',
    method: 'post',
    data
  })
}
